var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonVeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.4375,
    y: 0.4375,
    width: 13.125,
    height: 13.125,
    rx: 3.0625,
    transform: "matrix(-1 0 0 1 13.125 0)",
    stroke: "#FF3B30",
    strokeWidth: 0.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52539 4.41C7.29188 4.00556 6.70812 4.00556 6.47461 4.41L4.4943 7.84C4.26079 8.24444 4.55268 8.75 5.01969 8.75H8.98031C9.44732 8.75 9.73921 8.24444 9.5057 7.84L7.52539 4.41Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVeg);
export default __webpack_public_path__ + "static/media/Non_Veg.be4d28636460ee201fb15980cf613332.svg";
export { ForwardRef as ReactComponent };